import type { ProcessEntity } from '@common/enums/processEntity';
import type { ServiceCode } from '@common/enums/serviceCode';
import { fetchJson } from '@frontend/store/fetch';

export async function createAddendum({
    id,
    processEntity,
    properties,
    serviceCode,
    signal,
}: {
    id: string;
    processEntity: ProcessEntity;
    properties: Record<string, string>;
    serviceCode: ServiceCode;
    signal: AbortSignal;
}): Promise<void> {
    const url = '/api/addendums';
    const body = {
        addendum: {
            id,
            processEntity,
            properties,
        },
        serviceCode,
    };

    await fetchJson({
        body,
        method: 'POST',
        signal,
        url,
    });
}
